import {
    Container,
    Title,
    Text,
    Paper,
    Center,
    ThemeIcon,
    Box,
} from "@mantine/core";
import IconLock from "./assets/lock.svg?react";
import {useAppSelector} from "./app/hooks";
import {selectIsForbidden} from "./features/auth/forbiddenSlice";
import {useTranslation} from "react-i18next";
import {DenyPopover} from "./DenyPopover";

export function AuthorizationGate({children}: {children: any}) {
    const isForbidden = useAppSelector(selectIsForbidden);
    const {t} = useTranslation();

    if (!isForbidden) {
        return children;
    }
    return (
        <DenyPopover
            icon={<IconLock />}
            title={t("forbidden.title")}
            description={t("forbidden.description")}
        />
    );
}
